export class AnalyticsServiceMock {
  trackPage = jest.fn().mockImplementation(() => Promise.resolve(true).then(() => null));

  trackPageAndEvent = jest.fn().mockImplementation(() => Promise.resolve(true).then(() => null));

  sendPageView = jest.fn().mockImplementation(() => Promise.resolve(true).then(() => null));

  trackButtonClick = jest.fn().mockImplementation(() => Promise.resolve(true).then(() => null));
}
